import React, { useState } from 'react'
import SampleDashboardLayout from './SampleDashboardLayout'
import DownloadButtons from '../../../components/downloadButtons/DownloadButtons'
import AllSettings from '../../../components/allSettings/AllSettings';

const SampleSetting = () => {

    const [showPass, setShowPass] = useState(false);
    const [changeCards, setChangeCards] = useState("")

    const passwordHideShow = () => {
        setShowPass(!showPass);
    }

    return (
        <>
            <SampleDashboardLayout>
               <AllSettings/>
            </SampleDashboardLayout >
        </>
    )
}

export default SampleSetting